import * as z from "zod";

export {
  changeMsisdnOrchestrator,
  ftthOrchestrator,
  multiOrderOrchestrator,
} from "@nju/data-access-portal-orchestrator";

export const verificationErrorResponse = z.object({
  code: z.enum(["50138", "50193", "50196", "50198", "50207", "50210", "50232"]),
});
